import React from 'react';
import './Header.css';
import { Link, useHistory } from 'react-router-dom';
import SearchIcon from '@material-ui/icons/Search';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import { useStateValue } from '../StateProvider/StateProvider';
import { auth } from '../../assets/js/firebase';

function Header() {
  const [{ totalCartItems, user }] = useStateValue();
  const history = useHistory();

  const handleAuthentication = () => {
    if (user) {
      auth.signOut();
      if (window.location.pathname !== '/') history.push('/');
    }
  };

  const setOrdersReturnLink = () => {
    sessionStorage['returnURL'] = '/orders';
  };

  return (
    <nav className="header">
      <Link to="/">
        <img
          className="header__logo"
          src="https://mikekitko.com/wp-content/uploads/2019/10/amazon-logo-white.png"
          alt=""
        />
      </Link>
      <div className="header__search">
        <input type="text" className="header__searchInput" />
        <SearchIcon className="header__searchIcon" />
      </div>
      <div className="header__nav">
        <Link to={!user ? '/login' : ''} className="header__link">
          <div onClick={handleAuthentication} className="header__option">
            <span className="header__optionLineOne">
              Hello, {user ? user.displayName.split(' ')[0] : 'Guest'}
            </span>
            <span className="header__optionLineTwo">
              {user ? 'Sign Out' : 'Sign In'}
            </span>
          </div>
        </Link>
        <Link to={user ? '/orders' : '/login'} className="header__link">
          <div className="header__option" onClick={setOrdersReturnLink}>
            <span className="header__optionLineOne">Returns</span>
            <span className="header__optionLineTwo">& Orders</span>
          </div>
        </Link>
        <Link to="/" className="header__link">
          <div className="header__option">
            <span className="header__optionLineOne">Your</span>
            <span className="header__optionLineTwo">Prime</span>
          </div>
        </Link>
        <Link to="/checkout" className="header__link">
          <div className="header__optioncart">
            <ShoppingCartIcon />
            <span className="header__optionLineTwo header__cartCount">
              {totalCartItems ? totalCartItems : ''}
            </span>
          </div>
        </Link>
      </div>
    </nav>
  );
}

export default Header;
